export default __webpack_public_path__ + "static/media/ecomerce.f9411bb4.png";